var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "aside",
    [
      _c(
        "el-menu",
        {
          attrs: {
            mode: "horizontal",
            "default-active": _vm.$route.path,
            router: "",
          },
        },
        [
          _vm._l(_vm.admin_routes, function (item, index) {
            return [
              !item.children && !item.hidden
                ? _c(
                    "el-menu-item",
                    { key: index, attrs: { route: item, index: item.path } },
                    [
                      _c("i", { class: item.iconCls || "el-icon-s-claim" }),
                      _vm._v(" "),
                      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                        _vm._v(_vm._s(_vm.$t(item.name))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.children && !item.hidden
                ? _c(
                    "el-submenu",
                    { key: index, attrs: { index: index + "" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("i", { class: item.iconCls || "el-icon-s-claim" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { attrs: { slot: "title" }, slot: "title" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(item.children, function (child) {
                        return [
                          !child.hidden
                            ? _c(
                                "el-menu-item",
                                {
                                  key: child.path,
                                  attrs: { route: child, index: child.path },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [_vm._v(_vm._s(child.name))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }